const $window = $(window);
const $title = $('.lower-layout .title');
const $header = $('.header');
const $logo = $('.header__logo');

const OFFSET = 32;

PubSub.subscribe('scroll', () => {
    const scrollTop = $window.scrollTop();
    const headerTop = parseInt($header.css('padding-top')) + $logo.height();
    const overlap = scrollTop + headerTop + OFFSET;
    if (overlap > $title.offset().top) {
        $title.addClass('-hide');
    } else {
        $title.removeClass('-hide');
    }
  });
  